export default __webpack_public_path__ + "static/VehicleSliderWithTitleAndFilterActions-d0f7efe48b12eb1f5cc68d8176256b64.jpg";